import React from 'react';

const Header = ({ title }: { title: string | undefined }) => {
  return <div className='w-full text-[28px] font-semibold my-5'>{title}</div>;
};

export default Header;
